import React from 'react';
import { motion, useMotionValue } from 'framer-motion';
import { TrashIcon } from 'lucide-react';
import { useWindows, DOCK_APPS, APPS } from '../context/WindowsContext';
import { DockIcon } from './DockIcon';
export const Dock: React.FC = () => {
  const {
    openApps,
    focusedApp,
    openApp
  } = useWindows();
  const mouseX = useMotionValue(Infinity);
  return <div className="fixed bottom-4 left-0 right-0 flex justify-center z-50 pointer-events-none" data-id="element-319" data-mp="2emkjnbr0r7l3">
      <motion.nav initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 100,
      delay: 0.5
    }} className="pointer-events-auto bg-mac-glass backdrop-blur-xl border border-mac-border px-3 py-2 rounded-3xl shadow-mac-dock flex items-end gap-2" onMouseMove={e => mouseX.set(e.pageX)} onMouseLeave={() => mouseX.set(Infinity)} data-id="element-320" data-mp="32c51tsfcm0tb">
        {DOCK_APPS.map(appId => <DockIcon key={appId} app={APPS[appId]} mouseX={mouseX} isOpen={openApps.includes(appId)} isActive={focusedApp === appId} onClick={() => openApp(appId)} data-id="element-321" data-mp="257lzcn8rxaac" />)}

        <div className="w-[1px] h-10 bg-white/20 mx-1 self-center" data-id="element-322" data-mp="2a5x6gq7op6ov" />

        {/* Trash Icon (Decorative) */}
        <div className="relative group flex flex-col items-center" data-id="element-323" data-mp="2o56cwy638mfn">
          <div className="absolute -top-12 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-50" data-id="element-324" data-mp="2j7em67h6j6d1">
            <div className="bg-mac-glass backdrop-blur-md text-white text-xs px-3 py-1 rounded-md border border-mac-border shadow-lg whitespace-nowrap" data-id="element-325" data-mp="2xuzr86xm7fnl">
              Trash
            </div>
          </div>
          <motion.button className="w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg bg-white/10 text-white/80 backdrop-blur-md relative overflow-hidden border border-white/10" whileHover={{
          y: -5,
          scale: 1.1
        }} whileTap={{
          scale: 0.95
        }} onClick={() => alert('Trash is empty!')} data-id="element-326" data-mp="36xhdgld9s8al">
            <TrashIcon size={24} data-id="element-327" data-mp="28is95cbi2tax" />
          </motion.button>
          <div className="h-1 w-1 mt-1.5 rounded-full bg-transparent" data-id="element-328" data-mp="2dcn11319eel3" />
        </div>
      </motion.nav>
    </div>;
};